<template>
    <div class="Standard">
        <h2 v-html="content.title" class="page-title"></h2>
        <div v-html="content.content"></div>
    </div>
</template>

<script>
    export default {
        name:'standard',
        props: {
            content: Object
        },
        created() {
        }
    }
</script>

<style lang="scss">

</style>



